import { useContext, useEffect, useState } from "react";
import { AbilityContext } from "../../acl/can";
import { createClassAbility } from "../../acl/ability";
import StudentService from "../../services/StudentService";
import { canCreateOccurrence } from "../../utils/occurrenceAdvanced";

const canCreateInClass = async (classId, campusAbility, advanced) => {
  try {
    const classAbility = await createClassAbility(classId, campusAbility);
    return canCreateOccurrence(classAbility, advanced);
  } catch (err) {
    return false;
  }
};

export default function useCreatableStudentClasses(studentId, enabled, advanced) {
  const campusAbility = useContext(AbilityContext);
  const [classes, setClasses] = useState(undefined);

  useEffect(() => {
    if (!enabled || !studentId) {
      setClasses(undefined);
      return undefined;
    }

    let active = true;
    StudentService.getClasses(studentId)
      .then(async studentClasses => {
        const allowed = await Promise.all(
          studentClasses.map(item =>
            canCreateInClass(item.id, campusAbility, advanced)
          )
        );
        return studentClasses
          .filter((_, index) => allowed[index])
          .map(item => ({ id: String(item.id), name: item.name }));
      })
      .catch(() => [])
      .then(result => {
        if (active) setClasses(result);
      });

    return () => {
      active = false;
    };
  }, [studentId, enabled, advanced, campusAbility]);

  return classes;
}
